import { Helmet } from "react-helmet-async"
import { FEATURES } from "@/config/features"

interface SEOProps {
  title?: string
  description?: string
  keywords?: string
  image?: string
  url?: string
  type?: "website" | "article"
  noindex?: boolean
}

const BASE_URL = "https://welephant.xyz"
const DEFAULT_TITLE = FEATURES.mining ? "Prediction Mining Game" : "WELEPHANT"
const DEFAULT_DESCRIPTION = FEATURES.mining
  ? "Join the decentralized raffle mining game on BNB Chain. Mine tokens, stake rewards, swap assets, and bridge across chains. Fair, transparent, and community-driven."
  : "WELEPHANT — a community token on BNB Chain. Swap, stake for yield with stWELEPHANT, and bridge across chains. Fair, transparent, and community-driven."
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`

export function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords,
  image = DEFAULT_IMAGE,
  url,
  type = "website",
  noindex = false,
}: SEOProps) {
  const fullTitle = title
    ? `${title} | ${DEFAULT_TITLE}`
    : `${DEFAULT_TITLE} - ${FEATURES.mining ? "Decentralized Mining on BNB Chain" : "Community Token on BNB Chain"}`
  const fullUrl = url ? `${BASE_URL}${url}` : BASE_URL

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={DEFAULT_TITLE} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  )
}

export default SEO
